import React, { useCallback } from 'react';

import { EVENTS, trackEvent } from '@app/segment';
import ListMenu from '../shared/components/ListMenu';
import useAccountMenu from './hooks';
import AccountDropdown from './components/AccountDropdown';

type AccountMenuProps = {
  title?: string;
  format: 'list' | 'dropdown';
  handleClose?: Function;
  asMyAccountSidebarMenu?: boolean;
};

const AccountMenu = ({
  title,
  format,
  handleClose,
  asMyAccountSidebarMenu = false,
}: AccountMenuProps) => {
  const { items } = useAccountMenu();

  const handleOnClick = useCallback(
    (item) => {
      if (item?.eventLabel) {
        trackEvent(item?.eventLabel, {
          path: item.path,
          referrer: window?.location.origin,
          search: window?.location.search,
          category: 'Account Selling',
        });
      }

      if (!asMyAccountSidebarMenu) {
        trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
          label: item?.title,
        });
      }

      if (handleClose) {
        handleClose();
      }

      if (item?.onClick ?? undefined) {
        item.onClick();
      }
    },
    [asMyAccountSidebarMenu, handleClose],
  );

  if (format === 'dropdown') {
    return <AccountDropdown items={items} itemHandleOnClick={handleOnClick} />;
  }

  return (
    <ListMenu title={title} items={items} itemHandleOnClick={handleOnClick} />
  );
};

export default AccountMenu;
